import { Button } from "primereact/button";

import { ConfirmarSimulacaoDialog } from "../confirmar-simulacao-dialog";
import styles from "./desfazer-alteracao.module.scss";
import type { DesfazerAlteracaoViewModel } from "./types-desfazer-alteracao";

export function DesfazerAlteracaoView({
  testId,
  confirmando,
  titulo,
  mensagem,
  confirmarLabel,
  pedirConfirmacao,
  confirmar,
  cancelar,
}: DesfazerAlteracaoViewModel) {
  return (
    <>
      <Button
        type="button"
        className={styles.botaoDesfazer}
        icon="pi pi-replay"
        pt={{ icon: { className: styles.icone } }}
        aria-label="Desfazer alteração"
        tooltip="Desfazer Alteração"
        tooltipOptions={{ position: "left" }}
        onClick={pedirConfirmacao}
        data-testid={testId}
      />
      {confirmando ? (
        <ConfirmarSimulacaoDialog
          titulo={titulo}
          mensagem={mensagem}
          confirmarLabel={confirmarLabel}
          onConfirmar={confirmar}
          onCancelar={cancelar}
          testId={`${testId}-confirmacao`}
        />
      ) : null}
    </>
  );
}
